<template>
    <v-dialog v-model="dialog" width="480px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" color="primary" fab fixed right bottom dark>
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card light>
            <v-card-title>회원 추가</v-card-title>
            <v-divider />
            <v-card-text class="pa-6">
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="inputs.username" label="아이디" v-bind="inputProps"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="inputs.password" label="비밀번호" type="password" v-bind="inputProps"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-select v-model="inputs.type" :items="userTypes" label="유형" v-bind="inputProps" />
                    </v-col>
                    <v-col cols="6" v-if="isIndividual">
                        <v-select v-model="inputs.kind" :items="individualKinds" label="유형" v-bind="inputProps" />
                    </v-col>
                    <v-col cols="12" class="pb-0">
                        <v-row justify="space-around">
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="inputs.isApproval" label="가입 승인" v-bind="inputProps" :dense="false" />
                            </v-col>
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="inputs.isExpert" label="전문기업 승인" v-bind="inputProps" :dense="false" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import BuyerDetails from "@/components/console/user/buyer-details.vue";
import SellerDetails from "@/components/console/user/seller-details.vue";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/variables";

const organizationInputs = {
    type: USER_TYPES.ORGANIZATION,
};
const initialInputs = {
    username: "",
    password: "",
    isExpert: true,
    isApproval: true,
    ...organizationInputs,
};

const inputProps = {
    dense: true,
    inset: true,
    outlined: true,
    persistentPlaceholder: true,
    "hide-details": true,
    class: "my-0 py-0",
};

const userTypes = [
    { text: "기업회원", value: USER_TYPES.ORGANIZATION },
    { text: "일반회원", value: USER_TYPES.INDIVIDUAL },
];

const individualKinds = Object.keys(INDIVIDUAL_KINDS).map((value) => ({ text: INDIVIDUAL_KINDS[value], value }));

export default {
    components: {
        DaumPostcode,
        BuyerDetails,
        SellerDetails,
    },
    computed: {
        isIndividual() {
            return this.inputs.type == USER_TYPES.INDIVIDUAL;
        },
        user() {
            let { password, ...user } = this.inputs;
            password = CryptoAES.encrypt(password);

            return {
                ...user,
                password,
            };
        },
        isInputsOkay() {
            if (!this.inputs.username.length) throw new Error("아이디를 입력해주세요");
            if (!this.inputs.password.length) throw new Error("비밀번호를 입력해주세요");

            return true;
        },
    },
    data() {
        return {
            dialog: false,

            inputs: { ...initialInputs },

            userTypes,
            individualKinds,

            inputProps,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.inputs = { ...initialInputs };
        },
        async save() {
            try {
                if (this.isInputsOkay) {
                    const { user } = await api.console.users.post(this.user);
                    this.$emit("input", user);
                    this.dialog = false;
                    alert("추가되었습니다");
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        isIndividual() {
            if (this.isIndividual) this.inputs.kind = INDIVIDUAL_KINDS.SUPPORTER;
            else this.inputs.kind = null;
        },
        dialog() {
            if (this.dialog) this.init();
        },
    },
};
</script>
